export default __webpack_public_path__ + "asset/music/demo~31d6cfe0.mp3";